import React, { useState } from 'react';
import ConfirmByNameModal from '../../components/ConfirmByNameModal';
import logger from '../../utils/logger';

const sameId = (a, b) => String(a || '').replace(/-/g, '').toLowerCase() === String(b || '').replace(/-/g, '').toLowerCase();

/**
 * Список проектов в «Кабинеты, проекты, сотрудники»: сколько в проекте кабинетов и людей, открыть проект
 * и удалить пустой (или ненужный) проект. Удаление проекта кабинеты не затрагивает — они остаются без проекта.
 */
function ProjectsList({ workspaces, marketplaces, userId, request, reload, onOpenProject, showStatus }) {
  const [target, setTarget] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const cabinetName = (id) => {
    const item = marketplaces.find((m) => sameId(m.id, id));
    return item ? item.account_name || item.name : null;
  };

  const confirmDelete = async () => {
    setBusy(true);
    setError('');
    try {
      await request(`/api/v1/workspaces/${target.id}`, { method: 'DELETE' });
      showStatus && showStatus('success', 'Проект удалён. Кабинеты проекта сохранены.');
      setTarget(null);
      if (reload) await reload();
    } catch (err) {
      logger.error(err);
      setError(err?.message || 'Не удалось удалить проект.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ borderTop: '2px solid var(--surface-border)', paddingTop: '24px', marginTop: '24px' }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600, color: 'var(--ink)' }}>Проекты</h3>
      <div className="panel">
        {workspaces.length === 0 ? (
          <div style={{ padding: '24px', textAlign: 'center', color: 'var(--text-muted)' }}>Проектов пока нет.</div>
        ) : (
          <div style={{ display: 'grid', gap: 8 }}>
            {workspaces.map((workspace) => {
              const isOwner = sameId(workspace.owner_user_id, userId);
              const names = (workspace.cabinets || []).map((c) => cabinetName(c.marketplace_account_id)).filter(Boolean);
              const members = (workspace.members || []).length;
              return (
                <div
                  key={workspace.id}
                  style={{ display: 'grid', gridTemplateColumns: 'minmax(160px, 1.2fr) minmax(160px, 2fr) auto', gap: 12, alignItems: 'center', padding: '10px 4px', borderBottom: '1px solid var(--surface-border)' }}
                >
                  <div>
                    <strong>{workspace.name}</strong>
                    <div className="muted" style={{ fontSize: 13 }}>
                      {isOwner ? 'Владелец' : 'Участник'}{members ? ` · сотрудников: ${members}` : ''}
                    </div>
                  </div>
                  <div style={{ fontSize: 14 }}>
                    {names.length ? names.join(', ') : <span className="muted">Нет кабинетов</span>}
                  </div>
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                    {onOpenProject && (
                      <button type="button" className="ghost" onClick={() => onOpenProject(workspace.id)}>Открыть</button>
                    )}
                    {isOwner && (
                      <button type="button" className="ghost danger" onClick={() => { setError(''); setTarget(workspace); }}>Удалить</button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {target && (
        <ConfirmByNameModal
          title="Удалить проект?"
          expectedName={target.name}
          confirmLabel="Удалить проект"
          busy={busy}
          error={error}
          onClose={() => setTarget(null)}
          onConfirm={confirmDelete}
          description={(
            <>
              <p>Проект «{target.name}» и доступы сотрудников к нему будут удалены.</p>
              <p><strong>Кабинеты этого проекта не удаляются</strong> — они останутся в сервисе без проекта.</p>
              <p className="muted">Если в проекте есть задачи, сначала удалите их или перенесите в другой проект.</p>
            </>
          )}
        />
      )}
    </div>
  );
}

export default ProjectsList;
